import clsx from "clsx";
import { ShapeProps } from "./types";
import HeartIcon from "@mixitone/icons/shape-heart.svg";

export const Heart: React.FC<ShapeProps> = ({ color, size, className, style, children }) => {
  return (
    <div
      className={clsx("relative flex items-center justify-center", className)}
      aria-roledescription="color dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <HeartIcon className="absolute inset-0" width={size} height={size} style={{ fill: color }} />
      <span
        className="relative font-bold"
        style={{
          fontSize: `${size / 2}px`,
        }}
      >
        {children}
      </span>
    </div>
  );
};
